import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import App from './App';
import ForgottenPassword from './Auth/ForgottenPassword';
import Login from './Auth/Login';
import Logout from './Auth/Logout';
import MyAppHandler from './MyAppHandler';

@inject('authStore')
@observer
class AppRouter extends Component {
  render() {
    const { isLoggedIn } = this.props.authStore;
    return (
      <Router>
        <Switch>
          <Route path="/logout" component={Logout} />
          <Route path="/login" component={Login} />
          <Route path="/forgotten-password" component={ForgottenPassword} />
          <Route path="/myapp" component={MyAppHandler} />
          <Route path="/" render={() => (isLoggedIn ? <App /> : <Redirect to="/login" />)} />
        </Switch>
      </Router>
    );
  }
}

export default AppRouter;
